<template>
  <div class="row">
    <div class="js-body">
      <div id="js-results" class="row d-flex justify-content-center">
        <div class="row mx-auto">
          <div class="col-lg-6">
            <apnic-contacts :result="resultData"></apnic-contacts>
            <apnic-organisation :result="resultData"></apnic-organisation>
            <apnic-events :result="resultData"></apnic-events>
          </div>
          <div class="col-lg-6">
            <apnic-general :result="resultData"></apnic-general>
            <apnic-notices :result="resultData"></apnic-notices>
            <apnic-links :result="resultData"></apnic-links>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contacts from "./result/Contacts";
import Organisation from "./result/Organisation";
import Events from "./result/Events";
import Notices from "./result/Notices";
import General from "./result/General";
import Links from "./result/Links";
export default {
	data() {
		return {
			// resultData: null
		};
	},
	computed: {
		resultData() {
			return this.$store.getters["searchStore/data"];
		}
	},
	methods: {
		parseDescription(array) {
			if (array.length > 0) {
				const desc = array[0].description;
				const result = desc.join("</ br>");
				return result;
			}
			return "";
		}
	},
	components: {
		apnicContacts: Contacts,
		apnicLinks: Links,
		apnicGeneral: General,
		apnicNotices: Notices,
		apnicEvents: Events,
		apnicOrganisation: Organisation
	}
};
</script>

<style scoped>
</style>
